import api from ".";
import generateHeaders from "../utils/generateHeaders";

export async function checkAiCreatorPermission({
  token,
  opportunityId,
  eventId,
}) {
  const headers = generateHeaders(token);
  const options = {
    ...headers,
  };
  return await api.get(
    `/media-kit/verify-access/${eventId}/${opportunityId}`,
    options
  );
}

export async function getGeneratedImagesService({ token, opportunityId }) {
  const headers = generateHeaders(token);
  return await api.get(`/media-kit/generated-images/${opportunityId}`, headers);
}

export async function getMediaKitImagesService({ token, opportunityId }) {
  const headers = generateHeaders(token);
  return await api.get(`/media-kit/${opportunityId}`, headers);
}

export async function getMediaKitReportAdminService({
  token,
  eventId,
  year,
  search,
  page,
  per_page,
  sortBy,
  status,
  order,
}) {
  const headers = generateHeaders(token);

  const options = {
    ...headers,
    params: removeUndefined({
      event_id: eventId,
      year,
      search,
      page,
      per_page,
      sort_by: sortBy,
      order,
      created: status,
    }),
  };

  return await api.get("/media-kit/admin", options);
}

const removeUndefined = (obj) =>
  Object.fromEntries(Object.entries(obj).filter(([_, value]) => value));
